// extracted by mini-css-extract-plugin
module.exports = {"iconImage":"CategoryIcon_iconImage__1d8gn","iconText":"CategoryIcon_iconText__2b1Nz"};